import Vue from 'vue'
import myRefreshMore from './my-refresh-more.vue'
import mySwiperCard from './my-swiper-card.vue'
import mySwiperCard2 from './my-swiper-card2.vue'
import myCouponReceiveList from './my-coupon-receive-list.vue'
import myCouponOwnList from './my-coupon-own-list.vue'
import myShoppingCardList from './my-shoppingcard-list.vue'
import mBase from './module/base.vue'
import mSwiperSearch from './module/swiper-search.vue'
import mSwiper from './module/swiper.vue'
import mSearch from './module/search.vue'
import mBoxProduct from './module/box-product.vue'
import mImgOne from './module/img-one.vue'
import mImgTwo from './module/img-two.vue'
import mImgMore from './module/img-more.vue'
import mTreOne from './module/tre-one.vue'
import mTreTwo from './module/tre-two.vue'
import mTreMore from './module/tre-more.vue'
import mFriend from './module/friend.vue'
import mNav from './module/nav.vue'
import mHeader from './module/header.vue'
import mOpen from './module/open.vue'
import mVideo from './module/video.vue'
import mSwiperCard from './module/swiper-card.vue'
import mSwiperCard2 from './module/swiper-card2.vue'
import mRecommend from './module/recommend.vue'
import mSwiperLrregular from './module/swiper-lrregular.vue'
import mImgText from './module/img-text.vue'
Vue.component('my-refresh-more', myRefreshMore)
Vue.component('my-swiper-card', mySwiperCard)
Vue.component('my-swiper-card2', mySwiperCard2)
Vue.component('my-coupon-receive-list', myCouponReceiveList)
Vue.component('my-coupon-own-list', myCouponOwnList)
Vue.component('my-shoppingcard-list', myShoppingCardList)
Vue.component('m-base', mBase)
Vue.component('m-swiper-search', mSwiperSearch)
Vue.component('m-swiper', mSwiper)
Vue.component('m-search', mSearch)
Vue.component('m-box-product', mBoxProduct)
Vue.component('m-img-one', mImgOne)
Vue.component('m-img-two', mImgTwo)
Vue.component('m-img-more', mImgMore)
Vue.component('m-tre-one', mTreOne)
Vue.component('m-tre-two', mTreTwo)
Vue.component('m-tre-more', mTreMore)
Vue.component('m-friend', mFriend)
Vue.component('m-nav', mNav)
Vue.component('m-header', mHeader)
Vue.component('m-open', mOpen)
Vue.component('m-video', mVideo)
Vue.component('m-swiper-card', mSwiperCard)
Vue.component('m-swiper-card2', mSwiperCard2)
Vue.component('m-recommend', mRecommend)
Vue.component('m-swiper-lrregular', mSwiperLrregular)
Vue.component('m-img-text', mImgText)